/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getLabTestCategoryGroups } from 'app/entities/lab-test-category-group/lab-test-category-group.reducer';
import { getEntities as getLabTestCategories } from 'app/entities/lab-test-category/lab-test-category.reducer';
import { getEntities as getDiagLabPanels } from 'app/entities/diag-lab-panel/diag-lab-panel.reducer';
import { getEntities as getImageTests } from 'app/entities/image-tests/image-tests.reducer';
import { AssociationType } from 'app/shared/model/enumerations/association-type.model';
import { createEntity, getEntity, reset, updateEntity } from './lab-test-group-item.reducer';

export const LabTestGroupItemUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const labTestCategoryGroups = useAppSelector(state => state.labTestCategoryGroup.entities);
  const labTestCategories = useAppSelector(state => state.labTestCategory.entities);
  const diagLabPanels = useAppSelector(state => state.diagLabPanel.entities);
  const imageTests = useAppSelector(state => state.imageTests.entities);
  const labTestGroupItemEntity = useAppSelector(state => state.labTestGroupItem.entity);
  const loading = useAppSelector(state => state.labTestGroupItem.loading);
  const updating = useAppSelector(state => state.labTestGroupItem.updating);
  const updateSuccess = useAppSelector(state => state.labTestGroupItem.updateSuccess);
  const associationTypeValues = Object.keys(AssociationType);

  const handleClose = () => {
    navigate(`/lab-test-group-item${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getLabTestCategoryGroups({}));
    dispatch(getLabTestCategories({}));
    dispatch(getDiagLabPanels({}));
    dispatch(getImageTests({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }

    const entity = {
      ...labTestGroupItemEntity,
      ...values,
      lcGroupItem: labTestCategoryGroups.find(it => it.id.toString() === values.lcGroupItem?.toString()),
      lcTestCategory: labTestCategories.find(it => it.id.toString() === values.lcTestCategory?.toString()),
      panel: diagLabPanels.find(it => it.id.toString() === values.panel?.toString()),
      imageTest: imageTests.find(it => it.id.toString() === values.imageTest?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          testType: 'PATHOLOGY',
          ...labTestGroupItemEntity,
          lcGroupItem: labTestGroupItemEntity?.lcGroupItem?.id,
          lcTestCategory: labTestGroupItemEntity?.lcTestCategory?.id,
          panel: labTestGroupItemEntity?.panel?.id,
          imageTest: labTestGroupItemEntity?.imageTest?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.labTestGroupItem.home.createOrEditLabel" data-cy="LabTestGroupItemCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.labTestGroupItem.home.createOrEditLabel">Create or edit a LabTestGroupItem</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="lab-test-group-item-id"
                  label={translate('tinyMedicRestApp.labTestGroupItem.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestGroupItem.active')}
                id="lab-test-group-item-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestGroupItem.lastupdated')}
                id="lab-test-group-item-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestGroupItem.microSec')}
                id="lab-test-group-item-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestGroupItem.timestampentry')}
                id="lab-test-group-item-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestGroupItem.cursor')}
                id="lab-test-group-item-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.labTestGroupItem.testType')}
                id="lab-test-group-item-testType"
                name="testType"
                data-cy="testType"
                type="select"
              >
                {associationTypeValues.map(associationType => (
                  <option value={associationType} key={associationType}>
                    {translate(`tinyMedicRestApp.AssociationType.${associationType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="lab-test-group-item-lcGroupItem"
                name="lcGroupItem"
                data-cy="lcGroupItem"
                label={translate('tinyMedicRestApp.labTestGroupItem.lcGroupItem')}
                type="select"
              >
                <option value="" key="0" />
                {labTestCategoryGroups
                  ? labTestCategoryGroups.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-group-item-lcTestCategory"
                name="lcTestCategory"
                data-cy="lcTestCategory"
                label={translate('tinyMedicRestApp.labTestGroupItem.lcTestCategory')}
                type="select"
              >
                <option value="" key="0" />
                {labTestCategories
                  ? labTestCategories.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-group-item-panel"
                name="panel"
                data-cy="panel"
                label={translate('tinyMedicRestApp.labTestGroupItem.panel')}
                type="select"
              >
                <option value="" key="0" />
                {diagLabPanels
                  ? diagLabPanels.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="lab-test-group-item-imageTest"
                name="imageTest"
                data-cy="imageTest"
                label={translate('tinyMedicRestApp.labTestGroupItem.imageTest')}
                type="select"
              >
                <option value="" key="0" />
                {imageTests
                  ? imageTests.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/lab-test-group-item" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default LabTestGroupItemUpdate;
